import { Injectable, inject, signal } from '@angular/core';
import { AppSettings } from '../config';
import { APP_SETTINGS_DEFAULTS } from '../app-settings.token';

const THEME_STORAGE_KEY = 'theme';

function loadStoredOptions(defaults: AppSettings): AppSettings {
  try {
    const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
    if (storedTheme === 'light' || storedTheme === 'dark') {
      return { ...defaults, theme: storedTheme };
    }
  } catch {
    // ignore malformed/unavailable storage and fall back to defaults
  }
  return defaults;
}

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  private defaults = inject(APP_SETTINGS_DEFAULTS);
  private optionsSignal = signal<AppSettings>(loadStoredOptions(this.defaults));

  getOptions() {
    return this.optionsSignal();
  }

  setOptions(options: Partial<AppSettings>) {
    this.optionsSignal.update((current) => ({
      ...current,
      ...options,
    }));
    if (options.theme) {
      localStorage.setItem(THEME_STORAGE_KEY, options.theme);
    }
  }

  setLanguage(lang: string) {
    this.setOptions({ language: lang });
  }

  getLanguage() {
    return this.getOptions().language;
  }
}
